import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { queryClient } from "@/shared/services/queryClient";
import { expoPerformanceReportsApi } from "../services/expoPerformanceReportsApi";

const invalidateHistory = (expoId?: string) => {
  queryClient.invalidateQueries({ queryKey: ["expo-performance-reports-history"] });
  if (expoId) {
    queryClient.invalidateQueries({ queryKey: ["expo-performance-reports-history", expoId] });
  }
};

export const useExpoPerformanceReportHistory = (expoId?: string) =>
  useQuery({
    queryKey: ["expo-performance-reports-history", expoId],
    queryFn: () => expoPerformanceReportsApi.getHistory(expoId),
    enabled: !!expoId,
  });

export const useExpoPerformanceReportDetail = (reportId?: string) =>
  useQuery({
    queryKey: ["expo-performance-report-detail", reportId],
    queryFn: () => expoPerformanceReportsApi.getReport(reportId!),
    enabled: !!reportId,
  });

export const useResendExpoPerformanceReport = (expoId?: string) =>
  useMutation({
    mutationFn: (reportId: string) => expoPerformanceReportsApi.resend(reportId),
    onSuccess: () => {
      invalidateHistory(expoId);
      toast.success("Report email resend started.");
    },
  });

export const useRegenerateExpoPerformanceReport = (expoId?: string) =>
  useMutation({
    mutationFn: ({ reportId, reason }: { reportId: string; reason?: string }) =>
      expoPerformanceReportsApi.regenerate(reportId, reason),
    onSuccess: () => {
      invalidateHistory(expoId);
      toast.success("Report regeneration queued.");
    },
  });
